"use client"

// import "../assets/css/app.css";
import _Header from "./Header";
import { useEffect } from "react";
import _Nav from "./_Nav";
import _Footer from "./_Footer";

// import file from "/logo1.png"

import { Badge, Image, Layout } from 'antd';

import "./../assets/css/style.css"
import "./../assets/css/style_dua.css"

import img from './../assets/img/top.png';
import { RandomText } from "../services/Text/RandomText";
import { SocketIO } from "../services/Text/GlobalText";
import { _Toastr } from "../services/Toastr/Notify/_Toastr";
import { SnippetsFilled } from "@ant-design/icons";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { acakText } from "../services/Crypto";
import { dataUser, getDataUser } from "../services/Cache/Auth";
import { APP_VERSION } from "services/String/string";
import { logo } from "auth/index.js";
import indikator from "../assets/img/load.gif"

function MainLayouts({ children }) {

  const history = useHistory()

  useEffect(() => {
    // SocketIO.on("refreshArsip", (data) => {
    //   _Toastr.success("Pembayaran berhasil terverifikasi !")
    // });

    var pb_id = dataUser.user && dataUser.user.id_pembeli

    SocketIO.on("konfirmasipembayaran", (data) => {
      if (data.pembeli_id == pb_id) {
        Swal.fire({
          icon: "success",
          title: "Suksess...",
          text: "Pembayaran anda berhasil diverifikasi, ",
          footer: '<div>Mohon tunggu untuk melakukan konseling ! </div>'
        });
      }
    })
    SocketIO.on("requestKonfirmasipembayaran", (data) => {

      var cekRole = getDataUser();

      // if(Object.keys(dataUser).length == 0) return
      var role = cekRole.user.role
      if (role != undefined && role == 'adm') {
        Swal.fire({
          title: "<strong style='color : red'>Permintaan <u> Konfirmasi Pembayaran </u></strong>  <br/> Atas Nama :  "
            + data.orderby.namapembeli + " (" + data.kons['kodeorderkonseling'] + ")",
          icon: "warning",
          html: `
          <img height =200 src="/img/perhatian.gif" style='border-radius : 10px' />
        `,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
          <i class="fa fa-thumbs-up"></i> Lihat Tagihan!`,
          confirmButtonAriaLabel: "Thumbs up, great!",
          cancelButtonText: `
          <i class="fa fa-thumbs-down"></i>`,
          cancelButtonAriaLabel: "Thumbs down"
        }).then((result) => {
          if (result.isConfirmed) {
            // history.push({
            //   pathname: '/OrderKonseling',
            //   search: '?konsId=' + data.kons.id + "&xtemp=" + acakText("123"),
            //   replace: "true"
            // })
            window.location.href = '/OrderKonseling?konsId=' + data.kons.id + '&xtemp=' + acakText("123")
          }
        });;
      }
    });

  }, []);

  const stile = {
    title: {
      fontWeight: "bold", borderColor: "orange", color: "#542615", marginBottom: "0px", marginTop: "5px",
      fontFamily: "AdventPro, Arial, serif",
      paddingBottom: "5px",
    }
  }
  const { Header, Content, Footer } = Layout;
  return (
    <Layout className="layout" style={{ background: "#E3FEF7" }}>

      <div className="body">
        <center>
          <div className="">
            <div className="status-online"  >
              <img width={30} src={indikator} alt="image" />
              <b>Petugas Gizi Sedang Online </b>
            </div>
            <h2 style={stile.title}> <span style={{ color: "#46d0e1" }}> KONSELING GIZI
            </span> <span style={{ color: '#E3FEF7', }}> RSUD H. MOH. RUSLAN KOTA MATARAM </span> </h2>
          </div>
        </center>
        <_Nav />
      </div>

      {/* <div className="d-flex hide-mobile" style={{ position: "absolute", right: "50px", top: "20px" }}>
        <Badge count={2} offset={[-5, 0]} className="text-center">
          <img src="/img/menunggupembayaran.png" alt="" width={30} />
         
        </Badge>
        <div style={{ width: "20px" }}>&nbsp;</div>
        <Badge count={2} offset={[-5, 0]} className="text-center">
          <img src="/img/pembayaran.png" alt="" width={30} />
       
        </Badge>
        <Badge count={2} offset={[-5, 0]} className="text-center">
          <img src="/img/success.png" alt="" width={30} />
        
        </Badge>
      </div> */}

      <div className="logo-app" >
        <Image src={logo} preview={false} />
      </div>
      <Content style={{ padding: '0 20px' }}>

        <div className="" style={{ background: "#E3FEF7", marginBottom: "20px" }}>

          {children}

        </div>
      </Content>
      <Footer style={{ textAlign: 'center', background:"rgb(183 226 222)" }}>simrs©rsudkotamataram 2024 <b>ver{APP_VERSION}</b> Created by <b> @FHD </b></Footer>
    </Layout>
  );
}

export default MainLayouts;